import { createApi } from "@reduxjs/toolkit/query/react";
import { cacheDurationSeconds } from "common/constants";
import { ISupportForm } from "redux/utils/interfaces";
import { baseQueryWithReauth } from "./utils/constants";

import {
	UserParams,
	generateStationCodeParams
} from "./utils/interfaces";

const getUrlParams = (args) => {
	if (!args.sortBy && !args.filterBy) {
		return `limit=${args.limit}&offset=${args.offset}`;
	} else if (args.sortBy && !args.filterBy) {
		return `limit=${args.limit}&sortBy=${args.sortBy}&offset=${args.offset}`;
	} else if (!args.sortBy && args.filterBy) {
		return `limit=${args.limit}&offset=${args.offset}&filterBy=${args.filterBy}`;
	} else if (args.sortBy && args.filterBy) {
		return `limit=${args.limit}&sortBy=${args.sortBy}&offset=${args.offset}&filterBy=${args.filterBy}`;
	}
	return `limit=${args.limit}&offset=${args.offset}`;
};

const getUrlParamsForTransactions = (args) => {
	if (!args.sortBy) {
		return `userName=${args.userName}&locationId.stationId=${args.locationIdStationId}&limit=${args.limit}&offset=${args.offset}&userId=${args.userId}`;
	}
	return `userName=${args.userName}&locationId.stationId=${args.locationIdStationId}&limit=${args.limit}&sortBy=${args.sortBy}&offset=${args.offset}&userId=${args.userId}`;
};

export const stationAPI = createApi({
	reducerPath: "station",
	baseQuery: baseQueryWithReauth,
	keepUnusedDataFor: cacheDurationSeconds,
	endpoints: (builder) => ({
		getStationCodes: builder.query<any, UserParams>({
			query: (args) => ({
				url: `get-station-access-codes?${getUrlParams(args)}`,
				// keepUnusedDataFor: 0
			}),
		}),
		generateStationCode: builder.mutation<any, generateStationCodeParams>({
			query: (data) => {
				const { selectedStation, email, expireAt } = data;
				return {
					url: "generate-station-code",
					method: "PUT",
					body: {
                        "email": email ? email : "",
                        "locationId.stationId": selectedStation ? selectedStation : "",
						"expireAt": expireAt ? expireAt : "",
					}
				}
			},
		}),
		getUserBilling: builder.query<any, any>({
			query: (args:any) => ({
				url: `get-user-statements?${getUrlParamsForTransactions(args)}`,
			}),
		}),
	}),
});

export const {
	useGetStationCodesQuery,
    useGenerateStationCodeMutation,
	useGetUserBillingQuery
} =
stationAPI;

